import type { BrandName } from './brandPaths'
import { BRAND_PATHS } from './brandPaths'

interface BrandIconProps {
  name: BrandName
  /** Rendered size in pixels. */
  size?: number | string
  className?: string
}

/**
 * Renders a technology or platform logo.
 *
 * Separate from `Icon` because brand marks use a 24x24 viewBox while the UI
 * glyphs use 256x256. Inherits `currentColor`, so the palette decides the
 * colour rather than each brand's own.
 */
export const BrandIcon = ({ name, size = '1em', className }: BrandIconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d={BRAND_PATHS[name]} />
  </svg>
)
